/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Highlight_ColorInputs */

const en_highlight_settings_highlight_color = /** @type {(inputs: Highlight_Settings_Highlight_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlight Color`)
};

const es_highlight_settings_highlight_color = /** @type {(inputs: Highlight_Settings_Highlight_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de resaltado`)
};

/**
* | output |
* | --- |
* | "Highlight Color" |
*
* @param {Highlight_Settings_Highlight_ColorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_highlight_color = /** @type {((inputs?: Highlight_Settings_Highlight_ColorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Highlight_ColorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_highlight_color(inputs)
	return en_highlight_settings_highlight_color(inputs)
});